import React, { useEffect, useState } from 'react';

let pushToast = () => {};

export function toast(message, type = 'info') {
  pushToast({ id: Date.now() + Math.random(), message, type });
}

export function ToastHost() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    pushToast = (item) => {
      setItems((prev) => [...prev, item].slice(-5));
      const ms = item.type === 'error' || item.type === 'warning' ? 6000 : 4000;
      setTimeout(() => {
        setItems((prev) => prev.filter((t) => t.id !== item.id));
      }, ms);
    };
    return () => {
      pushToast = () => {};
    };
  }, []);

  if (items.length === 0) return null;

  const tone = {
    success: 'bg-green-600',
    error: 'bg-red-600',
    warning: 'bg-amber-600',
    info: 'bg-blue-600',
  };

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 max-w-sm">
      {items.map((item) => (
        <div
          key={item.id}
          className={`${tone[item.type] || tone.info} text-white px-4 py-3 rounded-lg shadow-lg text-sm`}
          role="status"
        >
          {item.message}
        </div>
      ))}
    </div>
  );
}
